<div class="defect-severity-container">
  <div class="hs-header">
    <span class="hs-title">{{metricDisplayName}}</span>
    <div class="view-toggle">
      <button 
        class="toggle-btn"
        [class.active]="selectedView === 'overall'"
        (click)="onViewChange('overall')">
        Overall
      </button>
      <select 
        [(ngModel)]="selectedTestSuite"
        (change)="onTestSuiteChange()"
        [class.selected]="selectedTestSuite && selectedTestSuite !== ''"
        class="suite-select">
        <option value="" disabled selected>Test Suite</option>
        <option *ngFor="let suite of testSuites" [value]="suite">
          {{ suite }}
        </option>
      </select>
    </div>
  </div>
  <!-- Chart Section -->
  <div class="chart-wrapper">
    <div class="chart-container">
      <app-pie-chart
        [chartType]="'doughnut'"
        [data]="getChartData()"
        [backgroundColors]="getChartColors()"
        [meta]="getChartMeta()">
      </app-pie-chart>
    </div>
  </div>

  <!-- Severity Cards Grid -->
  <div class="severity-grid">
    <div 
      class="severity-card"
      [ngClass]="'severity-' + severity.name"
      *ngFor="let severity of getSeverities()">
      <div class="severity-indicator" [style.background-color]="getSeverityColor(severity.name)"></div>
      <div class="severity-content">
        <div class="severity-value">{{ severity.value }}</div>
        <div class="severity-label">{{ getSeverityLabel(severity.name) }}</div>
      </div>
      <div class="severity-percentage">{{ severity.percentage }}%</div>
    </div>
  </div>
</div>
